export function register() {
  if (!('serviceWorker' in navigator)) return

  let registration

  const checkForUpdate = () => {
    if (!document.hidden && registration) {
      registration.update().catch(err => console.error('SW update check failed', err))
    }
  }

  const start = () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/', updateViaCache: 'none' })
      .then(reg => {
        registration = reg
        checkForUpdate()
        document.addEventListener('visibilitychange', checkForUpdate)
        window.setInterval(checkForUpdate, 5 * 60 * 1000)
      })
      .catch(err => console.error('SW register failed', err))
  }

  if (document.readyState === 'complete') start()
  else window.addEventListener('load', start, { once: true })
}
